import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { timeAgo } from "../lib/format";
import { Bell } from "@phosphor-icons/react";

export function NotificationBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => { clearInterval(t); document.removeEventListener("mousedown", onClick); };
  }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notification-bell" onClick={() => { setOpen(!open); if (!open) load(); }}
        className="relative w-10 h-10 rounded-full flex items-center justify-center hover:bg-zinc-100 transition-colors active:scale-95">
        <Bell size={20} weight={data.unread ? "fill" : "regular"} />
        {data.unread > 0 && (
          <span data-testid="notification-count" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#FF5A36] text-white text-[10px] font-bold flex items-center justify-center">
            {data.unread}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-[340px] max-w-[92vw] bg-white rounded-2xl border border-zinc-200 shadow-xl overflow-hidden z-50" data-testid="notification-dropdown">
          <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-100">
            <span className="font-semibold">Notificaciones</span>
            {data.unread > 0 && (
              <button onClick={markAll} className="text-xs font-semibold text-[#FF5A36] hover:underline" data-testid="mark-all-read">
                Marcar todas
              </button>
            )}
          </div>
          <div className="max-h-[380px] overflow-y-auto no-scrollbar">
            {data.items.length === 0 ? (
              <div className="px-4 py-10 text-center text-sm text-zinc-500">No tienes notificaciones</div>
            ) : (
              data.items.map((n) => (
                <div key={n.id} className={`px-4 py-3 border-b border-zinc-50 ${!n.read ? "bg-[#FFF4F1]" : ""}`}>
                  <div className="flex justify-between gap-2">
                    <span className="text-sm font-semibold">{n.title}</span>
                    <span className="text-[10px] text-zinc-400 whitespace-nowrap">{timeAgo(n.createdAt)}</span>
                  </div>
                  <p className="text-xs text-zinc-600 mt-0.5">{n.message}</p>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
